module.exports = __webpack_public_path__ + "static/media/batch-actions.353be96a.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/legacy-app/batch-actions.md
// module id = 384
// module chunks = 0